<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconArrowLeft_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M18.25 10.75H9.6l2.245-4.52a.813.813 0 0 0-1.302-.935l-6.132 6.131a.813.813 0 0 0 0 1.15l6.132 6.13a.812.812 0 0 0 1.302-.936L9.6 13.25h8.651a1.25 1.25 0 0 0 0-2.5Z"
    />
</svg>
